import brown from "./../sounds/brown.ogg";
import grey from "./../sounds/grey.ogg";
import pink from "./../sounds/pink.ogg";
import purple from "./../sounds/purple.ogg";
import red from "./../sounds/red.ogg";
import green from "./../sounds/green.ogg";
import blue from "./../sounds/blue.ogg";
import yellow from "./../sounds/yellow.ogg";

export const colors = [
    {
      title: "brown",
      polish: "brązowy",
      image:
        "https://images.unsplash.com/photo-1518967174331-85b528d6dabd?ixlib=rb-1.2.1&auto=format&fit=crop&w=777&q=80",
        sounds: brown,
    },
    {
      title: "grey",
      polish: "szary",
      image:
        "https://images.unsplash.com/photo-1533035353720-f1c6a75cd8ab?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80",
        sounds: grey,
    },
    {
      title: "pink",
      polish: "różowy",
      image:
        "https://images.unsplash.com/photo-1543097676-44e5a5bd4ef1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
        sounds: pink,
    },
    {
      title: "purple",
      polish: "fioletowy",
      image:
        "https://images.unsplash.com/photo-1583339522870-0d9f28cef33f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
        sounds: purple,
    },
    {
      title: "red",
      polish: "czerwony",
      image:
        "https://images.unsplash.com/photo-1568561300108-e0c35b5f7c1c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=812&q=80",
        sounds: red,
    },
    {
      title: "green",
      polish: "zielony",
      image:
        "https://images.unsplash.com/photo-1561016444-14f747499547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=889&q=80",
        sounds: green,
    },
    {
      title: "blue",
      polish: "niebieski",
      image:
        "https://images.unsplash.com/photo-1578070181910-f1e514afdd08?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=804&q=80",
        sounds: blue,
    },
    {
      title: "yellow",
      polish: "żółty",
      image:
        "https://images.unsplash.com/photo-1521913626209-0fbf68f4c4b1?ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
        sounds: yellow,
    },
  ];
